import { IState } from './DashboardMaintenanceEnquiry.reducer';

export interface IActions {
    [DashboardMaintenanceEnquiryActionTypes.setDashboardId]?: IState['DashboardId'];
}

export enum DashboardMaintenanceEnquiryActionTypes {
    setDashboardId = 'setDashboardId',
}
